<template>
  <div class="row">
    <div v-if="terminal" class="col-md-12">
      <div class="card">
        <h2 class="card-header">Terminal details</h2>
        <div class="card-body">
          <h5 class="card-title">{{ terminal.name }}</h5>
          <h6 class="card-subtitle mb-4 text-muted">
            Terminal ID:
            <code>{{ terminal.id }}</code>
          </h6>

          <div class="row">
            <div class="col-md-6">
              <table class="table">
                <tbody>
                  <tr>
                    <th>Serial number</th>
                    <td>{{ terminal.serialNumber }}</td>
                  </tr>
                  <tr>
                    <th>Registered at</th>
                    <td>{{ terminal.createdAt | moment('YYYY-MM-DD HH:mm A') }}</td>
                  </tr>
                  <tr>
                    <th>Software status</th>
                    <td>
                      <span v-if="terminal.isUpToDate">Up to date</span>
                      <span v-else>Out of date</span>
                    </td>
                  </tr>
                  <tr>
                    <th>Last online</th>
                    <td>{{ terminal.lastSeenAt | moment('from', 'now') }}</td>
                  </tr>
                  <tr>
                    <th>Driver</th>
                    <td>
                      <router-link
                        v-if="terminal.isAllocated"
                        :to="`/account/drivers/${terminal.driverId}`"
                      >{{ terminal.driver.name }}</router-link>
                      <span v-else>Unallocated</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <img
                class="img img-responsive mx-auto d-block"
                :src="`/static/img/terminals/${terminal.model}-trans.png`"
                style="max-height: 250px"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="loading" class="spinner-container">
        <double-bounce size="60px"></double-bounce>
      </div>
    </div>
  </div>
</template>
  
<script>
import { DoubleBounce } from "vue-loading-spinner";

export default {
  name: "SalePage",
  components: {
    DoubleBounce
  },
  data() {
    return {
      error: null,
      loading: null,
      terminal: null
    };
  },
  props: ["terminalId"],
  beforeMount() {
    this.loading = true;
    this.axios
      .get(`/v1/terminals/${this.terminalId}?_expand=driver`)
      .then(response => {
        this.loading = false;
        this.terminal = response.data;
      })
      .catch(error => {
        this.loading = false;
        this.error = "Failed to load terminal";
      });
  }
};
</script>
